import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/pages.css";
import PortfolioImg from "../../assets/images/portfolio.png";
import Pagination from "../ui/Pagination";
import SearchBar from "../ui/SearchBar";
import "../../styles/banner.css";
import { getListBoardPortfolio } from "../../api";

const Banner = ({ backgroundImage, title, description }) => {
  return (
    <div className="page-banner" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="banner-content">
        <h1>{title}</h1>
        {typeof description === "string" ? <p>{description}</p> : Array.isArray(description) ? description.map((line, index) => <p key={index}>{line}</p>) : null}
      </div>
    </div>
  );
};

const Portfolio = () => {
  const navigate = useNavigate();

  // Pagination 시작
  const [currentPage, setCurrentPage] = useState(1);
  const [displayedPortfolios, setDisplayedPortfolios] = useState([]);
  const portfoliosPerPage = 12;
  const [dataCount, setDataCount] = useState(1);
  // Pagination 끝

  // 검색바
  // const [originalPortfolios, setOriginalPortfolios] = useState([]);
  // const [filteredPortfolios, setFilteredPortfolios] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // 초기 로드 시 모든 시공사례 설정
  useEffect(() => {
    (async () => {
      const res = await getListBoardPortfolio({
        category: "시공",
        page: currentPage,
        search: searchTerm.trim() || undefined,
      });
      const data = res.data.results;
      setDataCount(res.data.count);
      setDisplayedPortfolios(data);
    })();
  }, [currentPage, searchTerm]);

  // 페이지 변경 시 표시할 시공사례 업데이트
  // useEffect(() => {
  //   const indexOfLastPortfolio = currentPage * portfoliosPerPage;
  //   const indexOfFirstPortfolio = indexOfLastPortfolio - portfoliosPerPage;
  //   setDisplayedPortfolios(filteredPortfolios.slice(indexOfFirstPortfolio, indexOfLastPortfolio));
  // }, [currentPage, filteredPortfolios]);

  // 검색어에 따라 시공사례 필터링
  useEffect(() => {
    // if (searchTerm.trim() === "") {
    // setFilteredPortfolios(originalPortfolios);
    // } else {
    //   const filtered = originalPortfolios.filter(
    //     (portfolio) =>
    //       portfolio.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //       portfolio.category.toLowerCase().includes(searchTerm.toLowerCase())
    //   );
    //   setFilteredPortfolios(filtered);
    // }
    setCurrentPage(1);
  }, [searchTerm]);

  const handlePortfolioClick = (id) => {
    navigate(`/portfolio/${id}/`);
  };

  const handlePageChange = (pageNumber) => {
    const target = Math.max(1, Math.min(pageNumber, totalPages));
    setCurrentPage((prev) => (prev === target ? prev : target));
    window.scrollTo({
      top: document.querySelector(".portfolio-section").offsetTop - 100,
      behavior: "smooth",
    });
  };

  const handleSearch = (term) => {
    setCurrentPage(1);
    setSearchTerm(term);
  };

  const totalPages = Math.ceil((dataCount ?? 0) / portfoliosPerPage);
  const bannerDescription = ["에코텍글로벌은 현장의 소리를 기술로 품어냅니다.", "농가의 현실에 맞춘 설계와 철저한 시공 품질로, 믿을 수 있는 온실 환경을 제공합니다."];
  return (
    <div className="portfolio-container">
      <Banner backgroundImage={PortfolioImg} title="시공사례" description={bannerDescription} />
      <div className="portfolio-content">
        <div className="portfolio-description">
          <h2>온실시공 및 유지보수</h2>
          <p>
            유리온실시공, 알미늄체, 스크린설치, 모터수리 및 교체, 최첨단온실 목수, <br />
            차광막 설치, 유동팬 시공 등 토탈 온실시공 및 유지 보수를 진행하고 있습니다.
          </p>
        </div>
        <div className="portfolio-section">
          <div className="portfolio-info">
            <p>총 {dataCount}건</p>
            <SearchBar onSearch={handleSearch} placeholder="검색어를 입력하세요." />
          </div>
          <hr />

          {displayedPortfolios && displayedPortfolios.length > 0 ? (
            <div className="portfolio-grid">
              {displayedPortfolios.map((portfolio) => (
                <div
                  key={portfolio.id}
                  className="portfolio-box"
                  onClick={() => handlePortfolioClick(portfolio.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handlePortfolioClick(portfolio.id);
                    }
                  }}
                >
                  <div className="portfolio-thumbnail-container">
                    <img src={`${portfolio.thumbnail.file.url}`} alt={portfolio.title} className="portfolio-thumbnail" />
                    <div className="hover-overlay">
                      <span className="detail-text">자세히 보기</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" className="arrownew-icon">
                        <g data-name="그룹 62">
                          <g data-name="그룹 61">
                            <path
                              data-name="패스 44"
                              d="M9118.341 1662.063h23.6"
                              transform="translate(-9101.257 -1633.028)"
                              style={{ strokeLinecap: "round", stroke: "#fff", strokeWidth: "2px", fill: "none" }}
                            />
                            <path
                              data-name="패스 45"
                              d="m9187.706 1640.815 5.992 5.993-5.992 5.992"
                              transform="translate(-9153.012 -1617.773)"
                              style={{ strokeLinejoin: "round", strokeLinecap: "round", stroke: "#fff", strokeWidth: "2px", fill: "none" }}
                            />
                          </g>
                          <g data-name="타원 1" style={{ stroke: "#fff", strokeWidth: "2px", fill: "none" }}>
                            <circle cx="29" cy="29" r="29" style={{ stroke: "none" }} />
                            <circle cx="29" cy="29" r="28" style={{ fill: "none" }} />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="portfolio-title">
                    <span className="portfolio-category">{portfolio.portfolio_category || "시공작업"}</span>
                    <h3>{portfolio.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p>검색 결과가 없습니다.</p>
            </div>
          )}
          {totalPages > 1 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
